import React from "react";
import "./CheckboxGroup.scss";

export type CheckboxGroupItem = {
  id: string | number;
  label: string;
  isChecked?: boolean;
  isDisabled?: boolean;
};

export type CheckboxGroupProps = {
  items: CheckboxGroupItem[];
  onClick: (id: string | number) => void;
  title?: string;
};

export default function CheckboxGroup({ items = [], onClick, title }: CheckboxGroupProps) {
  return (
    <div className="checkbox-group" role="group" aria-label={title || "Checkbox group"}>
      {title && <div className="checkbox-group__title">{title}</div>}
      <ul className="checkbox-group__list">
        {items.map(({ id, label, isChecked = false, isDisabled = false }) => (
          <li key={id} className="checkbox">
            <label
              className={`checkbox__label ${isDisabled ? "is-disabled" : ""}`}
              onClick={(e) => e.stopPropagation()}
              onMouseDown={(e) => e.stopPropagation()}
              onPointerDown={(e) => e.stopPropagation()}
              onKeyDown={(e) => {
                if (e.key === " " || e.key === "Enter") {
                  e.stopPropagation();
                }
              }}
            >
              <input
                type="checkbox"
                className="checkbox__input"
                checked={isChecked}
                disabled={isDisabled}
                onClick={(e) => {
                  e.stopPropagation();
                  onClick?.(id);
                }}
                onMouseDown={(e) => e.stopPropagation()}
                onPointerDown={(e) => e.stopPropagation()}
                onKeyDown={(e) => {
                  if (e.key === " " || e.key === "Enter") {
                    e.stopPropagation();
                  }
                }}
                aria-disabled={isDisabled}
                readOnly
              />
              <span className="checkbox__box" aria-hidden />
              <span className="checkbox__text">{label}</span>
            </label>
          </li>
        ))}
      </ul>
    </div>
  );
}
